export const AUTH_LOGIN_REQUEST = '@auth/AUTH_LOGIN_REQUEST';
export const AUTH_LOGIN_SUCCESS = '@auth/AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_FAILURE = '@auth/AUTH_LOGIN_FAILURE';
